const Annex = require("./Annex");
const ArmedIntervention = require("./ArmedIntervention");
const Enslave = require("./Enslave");
const Infiltrate = require("./Infiltrate");
const Kidnap = require("./Kidnap");
const Occupy = require("./Occupy");
const Plunder = require("./Plunder");
const Raid = require("./Raid");
const Spy = require("./Spy");

module.exports = {
    Annex,
    ArmedIntervention,
    Enslave,
    Infiltrate,
    Kidnap,
    Occupy,
    Plunder,
    Raid,
    Spy
}